import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';

export class TranslateLocalLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private translationPaths: string[]
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const requests: Observable<any>[] = this.translationPaths.map(path =>
      this.http.get(`${path}/${lang}.json`).pipe(
        catchError(() => {
          console.warn(`Translation file not found: ${path}/${lang}.json`);
          return of({});
        })
      )
    );

    return forkJoin(requests).pipe(
      map(translations => {
        let mergedTranslation = {};
        translations.forEach(translation => {
          mergedTranslation = _.merge(mergedTranslation, translation);
        });
        return mergedTranslation;
      })
    );
  }
}
